import { AuthResponse, SignInResponse } from '../../types';

export enum RegistrationActionTypes {
  REGISTRATION = 'REGISTRATION',
  SUCCESS = 'REGISTRATION_SUCCESS',
  ERROR = 'REGISTRATION_ERROR',
}

export enum SignInActionTypes {
  SIGNIN = 'SIGNIN',
  SUCCESS = 'SUCCESS_SIGNIN',
  ERROR = 'ERROR_SIGNIN',
  SIGN_OUT = 'SIGN_OUT',
  REFRESH_AUTH = 'REFRESH_AUTH',
}

export type AuthAction =
  | RegistrationAction
  | RegistrationActionSuccess
  | RegistrationActionError
  | SignInAction
  | SignInActionSuccess
  | SignOutAction
  | SignInActionError
  | SignInActionRef;

interface RegistrationAction {
  type: RegistrationActionTypes.REGISTRATION;
  payload: string;
}
interface SignOutAction {
  type: SignInActionTypes.SIGN_OUT;
}
interface RegistrationActionSuccess {
  type: RegistrationActionTypes.SUCCESS;
  payload: AuthResponse;
}

interface RegistrationActionError {
  type: RegistrationActionTypes.ERROR;
  payload: string;
}

interface SignInAction {
  type: SignInActionTypes.SIGNIN;
}

interface SignInActionSuccess {
  type: SignInActionTypes.SUCCESS;
  payload: SignInResponse;
}

interface SignInActionError {
  type: SignInActionTypes.ERROR;
  payload: string;
}

interface SignInActionRef {
  type: SignInActionTypes.REFRESH_AUTH;
  payload: RefreshedUser;
}
interface RefreshedUser {
  token: string;
  user: AuthResponse;
}
